import React from 'react'

const Error = () => {
  return (
    <div className="h-screen flex flex-col justify-center items-center">
        <div className={"mb-4 text-2xl text-red-600"}>
            Access Restricted
        </div>
        <div className={"text-lg text-gray-700 text-center"}>
            You are not authorized to access this page. Please contact your administrator if you think this is a mistake.
        </div>
    </div>
  )
}

export default Error
